import { render, staticRenderFns } from "./RoomPasswordPage.vue?vue&type=template&id=101bb68c&lang=pug&"
import script from "./RoomPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./RoomPasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomPasswordPage.vue"
export default component.exports